<template>
  <div>
    <nav-bar></nav-bar>
    <div>
      <router-view key="app"></router-view>
    </div>
  </div>
</template>

<script>
import NavBar from "./components/web/NavBar.vue";
export default {
  components: { NavBar },
  name: "App",
};
</script>

<style scoped>
  body{
    background-color: gray !important;
  }
  #shareButton{
  display: none;
}
</style>
